import axios from "axios";
import { refreshSession } from "./authClient";

const API_BASE = process.env.REACT_APP_API_URL || "";

const apiClient = axios.create({
    baseURL: API_BASE,
    withCredentials: true
});

// Add response interceptor for 401 handling
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                await refreshSession();
                return apiClient(originalRequest);
            } catch (refreshError) {
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export async function getGoals(signal) {
    const resp = await apiClient.get("/api/goals", { signal });
    return resp.data;
}

export async function getGoal(id) {
    const resp = await apiClient.get(`/api/goals/${id}`);
    return resp.data;
}

export async function createGoal(goal) {
    const resp = await apiClient.post("/api/goals", goal, {
        headers: { "Content-Type": "application/json" }
    });
    return resp.data;
}

export async function updateGoal(id, goal) {
    const resp = await apiClient.put(`/api/goals/${id}`, goal, {
        headers: { "Content-Type": "application/json" }
    });
    return resp.data;
}

export async function deleteGoal(id) {
    const resp = await apiClient.delete(`/api/goals/${id}`);
    return resp.data;
}

export async function updateGoalProgress(id, amount) {
    const resp = await apiClient.patch(`/api/goals/${id}/progress`, amount, {
        headers: { "Content-Type": "application/json" }
    });
    return resp.data;
}
